import React, { Component } from "react"
import { withRouter } from "react-router-dom"
import Layout from "../../Layout"
import { TermoCircunstanciadoForm } from "../../modais"

class TermoCircunstanciadoEditForm extends Component {
  constructor() {
    super()
    this.onSuccess = this.onSuccess.bind(this)
  }
  onSuccess() {
    this.props.history.push("/termocircunstanciado")
  }
  render() {
    return (
      <Layout tabActive="Fiscalização">
        <TermoCircunstanciadoForm
          isEditing={true}
          callBackTermo={this.onSuccess}
        />
      </Layout>
    )
  }
}
export default withRouter(TermoCircunstanciadoEditForm)



// WEBPACK FOOTER //
// ./src/views/fiscalizacao/termo-circunstanciado/TermoCircunstanciadoEditForm.js